/**
 * Find and update or add a product selection
 * @param {Array} selectedProducts - Array of {id, qty} objects
 * @param {string} id - Product ID
 * @param {number} qty - Quantity
 * @returns {Array} New array of selected products (immutable)
 */
export const updateProductSelection = (selectedProducts, id, qty) => {
  const newSelectedProducts = [...selectedProducts];
  const selectedProduct = newSelectedProducts.find(
    (product) => product.id === id
  );

  if (selectedProduct) {
    if (qty > 0) {
      // Update quantity
      const productIndex = newSelectedProducts.findIndex(
        (product) => product.id === id
      );
      newSelectedProducts[productIndex] = { ...selectedProduct, qty };
    } else {
      // Remove product (qty is 0 or falsy)
      const productIndex = newSelectedProducts.findIndex(
        (product) => product.id === id
      );
      newSelectedProducts.splice(productIndex, 1);
    }
  } else if (qty > 0) {
    // Add new product
    newSelectedProducts.push({ id, qty });
  }

  return newSelectedProducts;
};

/**
 * Create analytics products array from selected products
 * @param {Array} selectedProducts - Array of {id, qty} objects
 * @param {Object} product - Full product object
 * @param {boolean} withTax - Whether to include tax in price
 * @returns {Array} Array of analytics product objects
 */
export const createAnalyticsProducts = (selectedProducts, product, withTax) => {
  return selectedProducts.map((selectedProduct) => {
    return {
      product,
      quantity: selectedProduct.qty,
      activeProductId: selectedProduct.id,
      price: product.getPrice(withTax, selectedProduct.id),
    };
  });
};
